<template>
  <div class="link-gateway-container">
    <div class="heading is-bold">
      Link Gateway
    </div>
    <div class="text-blocks">
      <div>
        To link a gateway you will need to use our mobile app
      </div>
      <div>
        Your mobile device needs to have NFC to identify a gateway
      </div>
      <AppStoreLinks
        is-narrow
        @store-click="trackClick"
      />
    </div>
    <Button
      text="Close"
      :on-click="goBack"
      is-text
      is-light
      has-padding
    />
  </div>
</template>

<script>
import Button from '../../components/atoms/button/button';
import AppStoreLinks from '../../components/atoms/links/app-store-links';
import { routeNames } from '../../constants';

export default {
  name: 'LinkGateway',
  components: {
    AppStoreLinks,
    Button,
  },
  methods: {
    goBack() {
      if (this.$route.name === routeNames.zones.linkZoneGateway) {
        this.$router.push({
          name: routeNames.zones.detail,
          params: {
            id: this.$route.params.id,
            teamId: this.$route.params.teamId,
          },
        });
      } else {
        this.$router.push({ name: routeNames.zones.list });
      }
    },
    trackClick(platform) {
      this.$root.trackEvent.clickAppStoreLink(
        platform,
        'Link Gateway',
      );
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/styles/_variables.scss';
@import '@/styles/_breakpoints.scss';
.link-gateway-container {
  height: 100%;
  background-color: rgba($black, 0.85);
  color: $white;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 30px 0;
  .heading {
    font-size: 1.125rem;
  }
  .text-blocks {
    display: flex;
    flex-grow: 1;
    flex-direction: column;
    justify-content: space-around;
    padding: 0 20px;
  }
}
</style>
